import {
  Input,Output,SimpleChanges,OnChanges,DoCheck,ViewChild,
  EventEmitter,AfterViewInit,
  Component,
  OnInit
} from '@angular/core';
import {ElementRef} from '@angular/core';
import {DatePickerComponent} from 'ng2-jalali-date-picker';
import * as moment from 'jalali-moment';
declare var $: any;
var parent;
@Component({

  selector: 'rw-date-picker',  // <home></home>

  styles: [require('./date-picker.component.css')],

  template: require('./date-picker.component.html')
})
export class PersianDatePickerComponent implements OnInit,OnChanges,DoCheck,AfterViewInit {
  @ViewChild('dayPicker') datePicker:DatePickerComponent;
  @ViewChild('dayPickerModal') el:ElementRef;
  @Input()minDate:Date;
  public minDateM;
  any;
  @Input()maxDate:Date;
  @Input()availableDates:Date[] ;
  @Input()selectedDate:Date;
  @Input()placeholderText:string='تاریخ';
  @Output()selectedDateChanged:EventEmitter<Date> = new EventEmitter();
  public tempDate:Date;
  public viewInited:boolean=false;
  public showCalendar:boolean=true;


  //OR if you have initial value you could use following code

  public dateObject:any = moment();
  public config:any;
  public configModal:any;

  @Input()
  public isModal:boolean=false;
  /**
   * TypeScript public modifiers
   */
  constructor() {

    parent = this;
    this.config = {

      isDayDisabledCallback: this.isDayDisabledCallback


    };
    //this.configModal = {
    //
    //  isDayDisabledCallback: this.isDayDisabledCallback,
    //  appendTo:this.el,
    //  allowMultiSelect:true
    //
    //
    //};
  }

  public ngOnInit() {
    this.minDate = new Date();
    this.minDateM = moment('1396-08-22', 'jYYYY,jMM,jDD');


  }

  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
    if(changes.availableDates)
    parent.updateCaledar()

  }
  ngAfterViewInit()
  {
   if(this.isModal)
    this.configModal = {

      isDayDisabledCallback: this.isDayDisabledCallback,
      appendTo:this.el.nativeElement



    };
    this.viewInited=true;
  }
  ngDoCheck() {
    if (this.dateObject != this.tempDate) {
      this.tempDate = this.dateObject;
      this.dateObjectChanged(this.dateObject);
    }
  }

  updateCaledar() {
  let parent=this;
    //$('.dp-calendar-nav-container-right').click();
    setTimeout(function(){
     parent.showCalendar=false;
      setTimeout(function(){
       parent.showCalendar=true;
      },1)

    },1)

  }
  noDayAvailable(date:any)
  {
    return false;
  }

  isDayDisabledCallback(date:any) {


    let isInList = false;
    if (parent.availableDates) {

      parent.availableDates.forEach((ad:Date)=> {
        if (ad.getDate() == date.toDate().getDate() &&
          ad.getMonth() == date.toDate().getMonth() &&
          ad.getFullYear() == date.toDate().getFullYear()) {
          isInList = true;
          return
        }
      });

    }
    if (isInList)return false;
    else
      return true;


  }

  public isInList(dateList:Date[], date:Date) {
    let isInList = false;
    if (dateList) {

      dateList.forEach((ad:Date)=> {
        if (ad.getDate() == date.getDate() &&
          ad.getMonth() == date.getMonth() &&
          ad.getFullYear() == date.getFullYear()) {
          isInList = true;
          return
        }
      });

    }
    return isInList;
  }

  public dateObjectChanged(dateObject:any):void {
    if (this.dateObjectIsValid(dateObject)) {
      this.selectedDate = this.convertMomentToDate(dateObject);

      this.selectedDateChanged.emit(this.selectedDate);
    }
    else {
      this.dateObject = null;
      this.selectedDate = null;
      this.selectedDateChanged.emit(null);
      // this.datePicker.api.open();
    }
  }

  public dateObjectIsValid(dateObject:any):boolean {
    if (dateObject) {
      if (dateObject.toDate()) {
        return this.isInList(this.availableDates, dateObject.toDate())
        //  return !(this.isDayDisabledCallback(dateObject))

      }
    }
    return false;
  }

  public convertMomentToDate(dateObject:any):Date {
    let retDate:Date;
    retDate = dateObject.toDate();
    this.correctTimeZone(retDate);
    return retDate;
  }

  public correctTimeZone(date:Date) {

    var n = date.getTimezoneOffset();
    date.setHours(12, 0, 0);

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/date-picker/date-picker.component.ts